<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="173"
    height="173"
    viewBox="0 0 173 173"
  >
    <defs>
      <linearGradient id="viral-graph-9-c" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stop-color="#58A0F8" class="linear-gradient-color1" />
        <stop
          offset="100%"
          stop-color="#2176DD"
          class="linear-gradient-color2"
        />
      </linearGradient>
      <path
        id="viral-graph-9-b"
        d="M155.496754,71.5190212 L165.132104,83.1874178 C157.622023,89.3820418 151.587228,97.2019088 147.525297,106.041095 L133.769263,99.7267629 C138.78632,88.8091229 146.232137,79.1608587 155.496754,71.5190212 Z"
      />
      <filter
        id="viral-graph-9-a"
        width="163.8%"
        height="157.9%"
        x="-31.9%"
        y="-23.2%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="3"
        />
        <feComposite
          in="shadowBlurOuter1"
          in2="SourceAlpha"
          operator="out"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0.333333333 0 0 0 0 0.623529412 0 0 0 0 0.976470588 0 0 0 0.5 0"
          class="color-matrix"
        />
      </filter>
      <linearGradient id="viral-graph-9-f" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stop-color="#64A9FE" class="linear-gradient-color3" />
        <stop
          offset="100%"
          stop-color="#1865C4"
          class="linear-gradient-color2"
        />
      </linearGradient>
      <path
        id="viral-graph-9-e"
        d="M78.3375,134.83871 C109.986868,134.83871 135.64375,109.19618 135.64375,77.5645161 C135.64375,45.9328525 109.986868,20.2903226 78.3375,20.2903226 C46.6881321,20.2903226 21.03125,45.9328525 21.03125,77.5645161 C21.03125,109.19618 46.6881321,134.83871 78.3375,134.83871 Z M78.3375,134.83871 C109.986868,134.83871 135.64375,109.19618 135.64375,77.5645161 C135.64375,45.9328525 109.986868,20.2903226 78.3375,20.2903226 C46.6881321,20.2903226 21.03125,45.9328525 21.03125,77.5645161 C21.03125,109.19618 46.6881321,134.83871 78.3375,134.83871 Z M78.3375,134.83871 C109.986868,134.83871 135.64375,109.19618 135.64375,77.5645161 C135.64375,45.9328525 109.986868,20.2903226 78.3375,20.2903226 C46.6881321,20.2903226 21.03125,45.9328525 21.03125,77.5645161 C21.03125,109.19618 46.6881321,134.83871 78.3375,134.83871 Z"
      />
      <filter
        id="viral-graph-9-d"
        width="141%"
        height="141%"
        x="-20.5%"
        y="-18.8%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="7.5"
        />
        <feComposite
          in="shadowBlurOuter1"
          in2="SourceAlpha"
          operator="out"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0.325490196 0 0 0 0 0.584313725 0 0 0 0 0.894117647 0 0 0 0.5 0"
          class="color-matrix"
        />
      </filter>
      <linearGradient
        id="viral-graph-9-g"
        x1="50%"
        x2="50%"
        y1="0%"
        y2="98.69%"
      >
        <stop offset="0%" stop-color="#FFF" />
        <stop
          offset="100%"
          stop-color="#D5E3F4"
          stop-opacity="0"
          class="linear-gradient-color2"
        />
      </linearGradient>
    </defs>
    <g fill="none" fill-rule="evenodd" transform="translate(8 18)">
      <path
        class="linear-gradient-color4"
        fill="#7BB8FF"
        fill-rule="nonzero"
        d="M144.399176,70.6947402 C143.533072,62.6330383 141.228043,55.0017648 137.745856,48.0625748 L147.111534,42.8706582 C151.276355,51.051089 154.027517,60.0711399 155.043402,69.6094069 L144.399176,70.6947402 Z M144.652717,73.6844429 L155.303463,72.5984447 C155.421644,74.3465696 155.481694,76.1106297 155.481694,77.8887097 C155.481694,87.1678781 140.387024,101.786182 140.904523,100.341195 C143.458017,93.2112007 144.783306,85.6463569 144.783306,77.8887097 C144.783306,76.4765969 144.739346,75.0747438 144.652717,73.6844429 Z M136.339849,45.4118726 C132.327563,38.2434291 127.028123,31.892094 120.754189,26.6703931 L127.244171,18.154302 C134.686875,24.2755552 140.965612,31.7592943 145.698474,40.2238661 L136.339849,45.4118726 Z M118.405432,24.8030063 C111.485655,19.5501258 103.507454,15.6176407 94.8466754,13.3812371 L97.1186839,2.91717447 C107.336736,5.49567584 116.745812,10.1061608 124.89043,16.2934557 L118.405432,24.8030063 Z M91.9253248,12.6970689 C87.4715696,11.7598352 82.8540158,11.2669355 78.12125,11.2669355 C73.3028033,11.2669355 68.5771953,11.7823617 64.0056988,12.7691773 L61.3928367,2.3883669 C66.8060542,1.19335874 72.4075225,0.568548387 78.12125,0.568548387 C83.6330534,0.568548387 89.0102432,1.14468209 94.1958178,2.23998635 L91.9253248,12.6970689 Z M61.0880798,13.4682283 C52.5960929,15.7066598 44.6989995,19.588266 37.8078542,24.8176203 L31.1254037,16.4591513 C39.2053296,10.2828276 48.4878415,5.70813185 58.476356,3.09194015 L61.0880798,13.4682283 Z M35.4593928,26.6843822 C28.4773879,32.4950396 22.6555654,39.7523803 18.4690017,48.114965 L8.82185955,43.4871243 C13.716789,33.6526371 20.5594815,25.128789 28.7776995,18.3268603 L35.4593928,26.6843822 Z M11.46423,77.3612903 L0.759577507,77.3612903 C0.832441979,66.4809904 3.15939927,55.9183374 7.53525195,46.1972513 L17.1890007,50.8282613 C13.5008468,59.1098163 11.5360635,68.0930046 11.4642307,77.3612903 Z M11.5071998,80.3612907 C11.8036338,88.4902137 13.5602883,96.3748525 16.6605955,103.729926 L6.80777614,107.911659 C3.14929041,99.2420233 1.09817923,89.9380488 0.796686673,80.3612906 L11.5071899,80.3612903 Z"
      />
      <path
        fill="#FFF"
        fill-rule="nonzero"
        d="M159.881 111.126L158.72 113.893 77.131 79.664 78.291 76.898z"
      />
      <g fill-rule="nonzero" transform="scale(-1 1) rotate(-45 0 449.586)">
        <use
          fill="#000"
          filter="url(#viral-graph-9-a)"
          xlink:href="#viral-graph-9-b"
        />
        <use fill="url(#viral-graph-9-c)" xlink:href="#viral-graph-9-b" />
      </g>
      <use
        fill="#000"
        filter="url(#viral-graph-9-d)"
        xlink:href="#viral-graph-9-e"
      />
      <ellipse
        cx="78.338"
        cy="77.565"
        rx="56.819"
        ry="56.79"
        fill="url(#viral-graph-9-f)"
        stroke="#181818"
        stroke-linejoin="round"
        stroke-opacity=".2"
      />
      <ellipse
        cx="78.338"
        cy="77.565"
        stroke="url(#viral-graph-9-g)"
        stroke-width="2"
        opacity=".402"
        rx="49.819"
        ry="49.79"
      />
      <path
        fill="#FFF"
        d="M69.6899414,97 L79.1030273,82.6958008 L78.1494141,82.6958008 C69.5053711,82.6958008 62.3378906,76.5742188 62.3378906,68.1455078 C62.3378906,60.0859375 69.0131836,52.8876953 78.2109375,52.8876953 C86.9780273,52.8876953 94.0224609,59.5629883 94.0224609,67.8994141 C94.0224609,70.7910156 93.1918945,73.375 91.6845703,75.5898438 L78.6416016,97 L69.6899414,97 Z M78.1494141,75.9589844 C82.6713867,75.9589844 86.3935547,72.4213867 86.3935547,68.0839844 C86.3935547,63.746582 82.6713867,60.2089844 78.1494141,60.2089844 C73.6582031,60.2089844 69.9667969,63.746582 69.9667969,68.0839844 C69.9667969,72.4213867 73.6582031,75.9589844 78.1494141,75.9589844 Z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Level9",
});
</script>
